import { useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';


export default function AddEnrollmentAdditionalInfoTab() {
    const [incident, setIncidentReported] = useState('');
    const handleChange = (event: SelectChangeEvent) => {
        setIncidentReported(event.target.value);
    };


    return (
        <Stack>
             <Stack
                sx={{
                    mt: 2,
                    ml: 6,
                    mr: 6,
                    p: 2,
                }}
            >
              <Typography sx={{
                  color: 'success.dark'
              }}>
                    Provide any additional details related to the enrolled person
                </Typography>
            </Stack>
            <Stack direction="row"
                spacing={2}
                sx={{
                    alignItems: 'center',
                    ml: 6,
                    mr: 7,
                    pl: 2,
                    pr: 2,
                }}
            >
                 <Select
                    sx={{
                        flex: '1 0 33%'
                    }}
                    value={incident}
                    onChange={handleChange}
                    displayEmpty={true}
                    inputProps={{ 'aria-label': 'Without label' }}
                >
                    <MenuItem disabled={true} value="">
                        Response Tags
                    </MenuItem>
                    <MenuItem value="babyformula">Baby formula</MenuItem>
                    <MenuItem value="alcohol">Alcohol</MenuItem>
                    <MenuItem value="deli-meat">Deli/Meat</MenuItem>
                    <MenuItem value="electronics">Electronics</MenuItem>
                </Select>

                <Select
                    sx={{
                        flex: '1 0 33%'
                    }}
                    value={incident}
                    onChange={handleChange}
                    displayEmpty={true}
                    inputProps={{ 'aria-label': 'Without label' }}
                >
                    <MenuItem disabled={true} value="">
                        Alert Approach
                    </MenuItem>
                    <MenuItem value="babyformula">Baby formula</MenuItem>
                    <MenuItem value="alcohol">Alcohol</MenuItem>
                    <MenuItem value="deli-meat">Deli/Meat</MenuItem>
                    <MenuItem value="electronics">Electronics</MenuItem>
                </Select>

                <Select
                    sx={{
                        flex: '1 0 33%'
                    }}
                    value={incident}
                    onChange={handleChange}
                    displayEmpty={true}
                    inputProps={{ 'aria-label': 'Without label' }}
                >
                    <MenuItem disabled={true} value="">
                        Incident Reported
                    </MenuItem>
                    <MenuItem value="babyformula">Baby formula</MenuItem>
                    <MenuItem value="alcohol">Alcohol</MenuItem>
                    <MenuItem value="deli-meat">Deli/Meat</MenuItem>
                    <MenuItem value="electronics">Electronics</MenuItem>
                </Select>
            </Stack>
            <Stack
                sx={{
                    mt: 2,
                    ml: 6,
                    mr: 5,
                    p: 2,
                }}
            >
              <Typography color="primary">
                    Attributes
                </Typography>
            </Stack>
            <Stack direction="row"
                spacing={2}
                sx={{
                    alignItems: 'center',
                    ml: 6,
                    mr: 7,
                    pl: 2,
                    pr: 2
                }}
            >
                 <Select
                    sx={{
                        flex: '1 0 33%'
                    }}
                    value={incident}
                    onChange={handleChange}
                    displayEmpty={true}
                    inputProps={{ 'aria-label': 'Without label' }}
                >
                    <MenuItem disabled={true} value="">
                        Gender
                    </MenuItem>
                    <MenuItem value="male">Male</MenuItem>
                    <MenuItem value="female">Female</MenuItem>
                </Select>

                <TextField
                    sx={{
                        '& label': {
                            color: 'primary.main',
                        },
                        flex: '1 0 33%'
                    }}
                    label="Height"
                    InputLabelProps={{
                        shrink: true,
                    }}
                    placeholder="ft’in”"
                />

                <TextField
                    sx={{
                        '& label': {
                            color: 'primary.main',
                        },
                        flex: '1 0 33%'
                    }}
                    label="Hair Color"
                    InputLabelProps={{
                        shrink: true,
                    }}
                    placeholder="Color"
                />

               
            </Stack>

            <Stack direction="row"
                spacing={2}
                sx={{
                    alignItems: 'center',
                    ml: 6,
                    mr: 7,
                    pl: 2,
                    pr: 2,
                    mt: 3
                }}
            >
                 <Select
                    sx={{
                        flex: '1 0 33%'
                    }}
                    value={incident}
                    onChange={handleChange}
                    displayEmpty={true}
                    inputProps={{ 'aria-label': 'Without label' }}
                >
                    <MenuItem disabled={true} value="">
                        Build
                    </MenuItem>
                    <MenuItem value="male">Male</MenuItem>
                    <MenuItem value="female">Female</MenuItem>
                </Select>

                <TextField
                    sx={{
                        '& label': {
                            color: 'primary.main',
                        },
                        flex: '1 0 33%'
                    }}
                    label="Weight"
                    InputLabelProps={{
                        shrink: true,
                    }}
                    placeholder="lbs"
                />

                <TextField
                    sx={{
                        '& label': {
                            color: 'primary.main',
                        },
                        flex: '1 0 33%'
                    }}
                    label="Eye Color"
                    InputLabelProps={{
                        shrink: true,
                    }}
                    placeholder="Color"
                />

               
            </Stack>

            <Stack
                sx={{
                    mt: 4,
                    ml: 6,
                    mr: 6,
                    pl: 2,
                }}
            >
                 <Typography color="primary">
                    Notes
                </Typography>
                <TextField
                    sx={{
                        mt: 1,
                        '& label': {
                            color: 'primary.main',
                        }
                    }}
                    multiline={true}
                    rows={4}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    placeholder="Here are additional notes around the event that could be noted"
                />


            </Stack>
            <Box
                sx={{
                    ml: 8,
                    mr: 8,
                    textAlign: 'right'
                }}
            >
                <Button
                    variant="contained" color="secondary"
                    size="large"
                    sx={{
                        mt: 4
                    }}
                >Enroll</Button>
            </Box>
        </Stack>

    )
}
